import { Link, useNavigate } from 'react-router-dom';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import SellIcon from '@mui/icons-material/Sell';
import GroupIcon from '@mui/icons-material/Group';
import ReviewsIcon from '@mui/icons-material/Reviews';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DescriptionIcon from '@mui/icons-material/Description';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AddBoxIcon from '@mui/icons-material/AddBox';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import PaymentIcon from '@mui/icons-material/Payment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import './Sidebar.css';
import { useSnackbar } from 'notistack';
import { logoutUser } from '../../../actions/userAction';

const navMenu = [
    {
        icon: <EqualizerIcon />,
        label: "Dashboard",
        ref: "/admin/dashboard",
        permissionKey: "dashboard",
    },
    {
        icon: <ShoppingBagIcon />,
        label: "Orders",
        ref: "/admin/orders",
        permissionKey: "orders",
    },
    {
        icon: <InventoryIcon />,
        label: "Products",
        ref: "/admin/products",
        permissionKey: "products",
    },
    {
        icon: <AddBoxIcon />,
        label: "Add Product",
        ref: "/admin/new_product",
        permissionKey: "products",
    },
    {
        icon: <CategoryIcon />,
        label: "Categories",
        ref: "/admin/categories",
        permissionKey: "categories",
    },
    {
        icon: <SellIcon />,
        label: "Brands",
        ref: "/admin/brands",
        permissionKey: "brands",
    },
    {
        icon: <GroupIcon />,
        label: "Users",
        ref: "/admin/users",
        adminOnly: true,
    },
    {
        icon: <ReviewsIcon />,
        label: "Reviews",
        ref: "/admin/reviews",
        permissionKey: "reviews",
    },
    {
        icon: <EditNoteIcon />,
        label: "Site Content",
        ref: "/admin/site-content",
        permissionKey: "siteContent",
    },
    {
        icon: <ViewHeadlineIcon />,
        label: "Header",
        ref: "/admin/header",
        permissionKey: "header",
    },
    {
        icon: <ViewStreamIcon />,
        label: "Footer",
        ref: "/admin/footer",
        permissionKey: "footer",
    },
    {
        icon: <LocalOfferIcon />,
        label: "Offers",
        ref: "/admin/offers",
        permissionKey: "offers",
    },
    {
        icon: <ConfirmationNumberIcon />,
        label: "Promo Codes",
        ref: "/admin/promo-codes",
        permissionKey: "promoCodes",
    },
    {
        icon: <LocalShippingIcon />,
        label: "Shipping Areas",
        ref: "/admin/shipping-areas",
        permissionKey: "shippingAreas",
    },
    {
        icon: <PersonPinIcon />,
        label: "Drivers",
        ref: "/admin/drivers",
        permissionKey: "drivers",
    },
    {
        icon: <DirectionsCarIcon />,
        label: "Vehicles",
        ref: "/admin/vehicles",
        permissionKey: "vehicles",
    },
    {
        icon: <NotificationsIcon />,
        label: "Notifications",
        ref: "/admin/notifications",
        permissionKey: "notifications",
    },
        {
        icon: <DescriptionIcon />,
        label: "Pages",
        ref: "/admin/pages",
        permissionKey: "pages",
    },
    {
        icon: <AdminPanelSettingsIcon />,
        label: "Role Management",
        ref: "/admin/roles",
        adminOnly: true,
    },
    {
        icon: <WallpaperIcon />,
        label: "Splash Screens",
        ref: "/admin/splash-screens",
        permissionKey: "splashScreen",
    },
    {
        icon: <PaymentIcon />,
        label: "Payment Gateways",
        ref: "/admin/payment-gateways",
        adminOnly: true,
    },
    {
        icon: <AssessmentIcon />,
        label: "Inventory Log",
        ref: "/admin/inventory-log",
        permissionKey: "inventoryLog",
    },
    {
        icon: <AccountBalanceWalletIcon />,
        label: "1313 Wallets",
        ref: "/admin/wallets",
        permissionKey: "wallet",
    },
    {
        icon: <AccountBalanceWalletIcon />,
        label: "Wallet Settings",
        ref: "/admin/wallet-settings",
        adminOnly: true,
    },
    {
        icon: <StorefrontIcon />,
        label: "Vendors",
        ref: "/admin/vendors",
        permissionKey: "vendors",
    },
    {
        icon: <AccountBoxIcon />,
        label: "My Profile",
        ref: "/account",
    },
    {
        icon: <LogoutIcon />,
        label: "Logout",
    },
];

const Sidebar = ({ activeTab, setToggleSidebar }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { user } = useSelector((state) => state.user);

    const isSuperAdmin = user.role === "admin";
    const staffPermissions = user.adminRole?.permissions || [];

    const handleLogout = () => {
        dispatch(logoutUser());
        enqueueSnackbar("Logout Successfully", { variant: "success" });
        navigate("/login");
    }

    return (
        <aside className="sidebar z-10 sm:z-0 block fixed left-0 top-16 h-[calc(100vh-4rem)] w-3/4 sm:w-1/5 bg-gray-800 text-white overflow-y-auto overflow-x-hidden border-r">
            <div className="flex items-center gap-3 bg-gray-700 p-2 rounded-lg shadow-lg my-4 mx-3.5">
                <Avatar
                    alt="Avatar"
                    src={user.avatar.url}
                />
                <div className="flex flex-col gap-0">
                    <span className="font-medium text-lg">{user.name}</span>
                    <span className="text-gray-300 text-sm">{user.email}</span>
                </div>
                <button onClick={()=>setToggleSidebar(false)} className="sm:hidden bg-gray-800 ml-auto rounded-full w-10 h-10 flex items-center justify-center">
                    <CloseIcon/>
                </button>
            </div>

            <div className="flex flex-col w-full gap-0 my-8">
                {navMenu.map((item, index) => {
                    const { icon, label, ref, permissionKey, adminOnly } = item;

                    const canView =
                        label === "My Profile" ||
                        label === "Logout" ||
                        isSuperAdmin ||
                        (!adminOnly && permissionKey && staffPermissions[permissionKey]?.view);

                    if (!canView) return null;

                    return (
                        <>
                            {label === "Logout" ? (
                                <button onClick={handleLogout} className="hover:bg-gray-700 flex gap-3 items-center py-3 px-4 font-medium">
                                    <span>{icon}</span>
                                    <span>{label}</span>
                                </button>
                            ) : (
                                <Link to={ref} className={`${activeTab === index ? "bg-gray-700" : "hover:bg-gray-700"} flex gap-3 items-center py-3 px-4 font-medium`}>
                                    <span>{icon}</span>
                                    <span>{label}</span>
                                </Link>
                            )}
                        </>
                    )
                }
                )}
            </div>

        </aside>
    )
};

export default Sidebar;